import type { QueryClient } from '@tanstack/react-query';
import { initDashboardQueryClient, type DashboardQueryInitOptions } from '@squareup/dashboard-query';

let fallbackQueryClient: QueryClient | null = null;

export function getFallbackQueryClient(options: DashboardQueryInitOptions = {}) {
  fallbackQueryClient ||= initDashboardQueryClient(options);

  return fallbackQueryClient;
}
